"use client";

import { usePathname } from "next/navigation";
import { ThemeProvider } from "next-themes";

// The admin panel is dark-only (owner-pinned). The force has to happen HERE,
// on the single root provider, via next-themes' forcedTheme:
//  - a nested <ThemeProvider> inside the admin layout is a no-op fragment in
//    next-themes 0.4.x (a provider context already exists above it);
//  - raw `document.documentElement.dataset.theme` writes get clobbered by the
//    provider's re-apply effect (see the warning in test-visual/mockup-screens);
//  - `setTheme("dark")` would PERSIST to localStorage and silently flip the
//    user's app-wide preference.
// forcedTheme wins every re-apply, never touches the stored "theme" key,
// restores the user's preference the moment they leave /admin, and flips
// `color-scheme` so native scrollbars/inputs go dark too.
// Locale prefix is always present (defineRouting default), so /ru/admin/…
// and /en/admin/… cover every admin URL.
const ADMIN_PATH = /^\/(ru|en)\/admin(?:\/|$)/;

export function AppThemeProvider({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  return (
    <ThemeProvider
      attribute="data-theme"
      defaultTheme="light"
      enableSystem={false}
      forcedTheme={ADMIN_PATH.test(pathname ?? "") ? "dark" : undefined}
    >
      {children}
    </ThemeProvider>
  );
}
